// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ref-title[data-v-4d6dcf2a],\n.ref-subtitle[data-v-4d6dcf2a] {\n  text-align: center;\n}\n.ref-subtitle[data-v-4d6dcf2a] {\n  line-height: 1.7;\n}\n.question[data-v-4d6dcf2a] {\n  text-transform: uppercase;\n  font-size: 1.4rem;\n  font-weight: bolder;\n  text-align: center;\n}\n.h1[data-v-4d6dcf2a] {\n  font-size: 4rem;\n}\n.h2[data-v-4d6dcf2a] {\n  font-size: 2rem;\n}", ""]);
// Exports
module.exports = exports;
